export enum BOOK_INVITE_ASSIGNMENT_STATUS {
    unassigned = 'unassigned',
    pending = 'pending',
    claimed = 'claimed',
    revoked = 'revoked',
    expired = 'expired',
}
